import { Step, StepFooter, StepWrapper } from './Step';
import { FieldSet } from './FieldSet';
import { Modal } from './Modal';
export const FormUiMap = {
  Step,
  FieldSet,
  StepFooter,
  StepWrapper,
  Modal
};
//# sourceMappingURL=es/FormUI/FormUiMap.js.map